import React, { useEffect, useState } from "react";
import "./AgentLeads.css";
import { API } from "../../constants/Api";
import { toast } from "react-toastify";
import { Modal } from "antd";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

function AgentZipCodes() {
  const token = localStorage.getItem("token");
  const agentId = localStorage.getItem("agentId");

  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedZipCodes, setSelectedZipCodes] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(0)
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openModal = (type) => setModalType(type);
  const closeModal = () => setModalType(null);

  const handleZipChange = (selectedOptions) => {
  
      setSelectedZipCodes(selectedOptions ? selectedOptions.map((opt) => opt.value) : []);
   
  };
  const getOptions = async (myData) => {
    try {
      const response = await fetch(`${API}/auth/role-check/available-for-showing-agents`);
      const json = await response.json();
  
      if (response.ok) {
        const allZipCodes = json.zipCodes.map((data) => ({
          label: data.zipCode,
          value: String(data.zipCode), // Ensure consistency in data type
        }));
  
        console.log("All Zip Codes:", allZipCodes);
        console.log("Existing Zip Codes:", myData);
  
        // Filter out already used zip codes
        const filteredOptions = allZipCodes.filter(
          (zip) => !myData.includes(String(zip.value))
        );
  
        console.log("Filtered Options:", filteredOptions);
  
        setOptions(filteredOptions);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  
  
  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await fetch(`${API}/agents/get-agent/${agentId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const json = await response.json();
  
        if (response.ok) {
          const zipCodes = json.data.agentzipCode.map(String); // Ensure array of strings
          console.log("Fetched Agent Zip Codes:", zipCodes);
          setData(zipCodes);
     
        }
      } catch (error) {
        toast.error(error.message);
      }
    };
  
    getUserInfo();
  }, [update, modalType]);

  
  useEffect(() => {
    if (data.length) {
      getOptions(data);
      setSelectedZipCodes([])
    }
  }, [data]); 
  const handleAdd = async () => {
    if (selectedZipCodes.length > 0) {
      const data = {
        zipCodes: selectedZipCodes,
      };
      const response = await fetch(`${API}/agents/${agentId}/zipcodes`, {
        method: "PATCH",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const json = await response.json();
  
      if (response.ok) {
        toast.success("Zip Codes added successfully");
        setUpdate(update+1) // Update the state with the new zip codes
        setSelectedZipCodes([]); // Clear the selected zip codes
        closeModal(); // Close the modal after adding
      }
    }
  };

  const columns = [
    {
      name: "Zip Code",
      selector: (row) => row,
      sortable: true,
    },
  ];


  const customStyles = {
    table: {
      style: {
        backgroundColor: "#252525!important",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e1e1e",
        color: "#ffffff",
        fontSize: "16px",
        fontFamily: "Degular-Light",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#ffffff",
      },
    },
    rows: {
      style: {
        backgroundColor: "#252525",
        fontFamily: "Degular-Light",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#e3f2fd",
        transition: "0.2s ease-in-out",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1e1e1e",
        fontSize: "14px",
        borderTop: "1px solid #ddd",
        color: "#ffffff",
      },
      pageButtonsStyle: {
        color: "#ffffff",
        fill: "#ffffff",
        "&:hover": {
          backgroundColor: "#252525",
          color: "#ffffff",
          fill: "#ffffff",
        },
        "&:disabled": {
          color: "#bdbdbd",
          fill: "#bdbdbd",
        },
      },
    },
  };


  const colorStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#252525",
      borderColor: state.isFocused ? "#252525" : "#252525",
      boxShadow: state.isFocused ? "none" : "none",
      borderRadius: "20px", // Adjust the border-radius as needed
      minHeight: "66px", // Increase the height
      padding: "10px",
      "&:hover": {
        borderColor: "#252525",
      },
      "&:focus": {
        borderColor: "#252525",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#24A97B"
        : state.isFocused
          ? "#252525"
          : "#252525",
      borderRadius: "20px",

      color: state.isSelected ? "black" : "white",
      "&:hover": {
        backgroundColor: "#000000",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#252525",
      border: "1px solid #252525",
      borderRadius: "20px", // Add border-radius to the dropdown menu
      fontFamily: "Degular-Light",
      fontSize: "14px",
      padding: "10px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
      opacity: "0.7",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    input: (base) => ({
      ...base,
      color: "#ffffff",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#000000",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  return (
    <div className="agent-lead">
      <h2 className="user-layout-page-heading">Zip Codes</h2>

      <div className="container-fluid agent-buy-leads-container">
    

        <Modal
          width={{
            xs: "100%",
            sm: "100%",
            md: "70%",
            lg: "70%",
            xl: "65%",
            xxl: "65%",
          }}
          centered
          open={modalType === "terms"}
          footer={null}
          closable={false}
        >
          <div
            className={`container-fluid pop-up-leads ${isMobile ? "px-0" : ""}`}
          >
            <h2 className="lead-pop-heading">Select Zip Codes to Add</h2>
            <div className="col-12" style={{ marginBottom: "20px" }}>
              <Select
                isMulti
                styles={colorStyles}
                options={options}
                classNamePrefix="select"
                placeholder="Choose Zip Codes..."
                onChange={handleZipChange}
                value={options.filter((opt) => selectedZipCodes.includes(opt.value))}

               
              />
            </div>
            <div className="row">
              <div className="col-md-6">
                <button
                  className="btn user-register-button"
                  onClick={handleAdd}
                >
                  Add
                </button>
              </div>
              <div className="col-md-6">
                <button
                  onClick={closeModal}
                  className="btn schedule-tour-skip-button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <div className="row">
          {data.length > 0 ? (
            <div className="col-12 px-0 pt-4">
              <DataTable
                columns={columns}
                data={data}
                pagination
                paginationPerPage={15}
                paginationRowsPerPageOptions={[10, 15, 20, 50]}
                customStyles={customStyles}
                progressPending={loading}
                progressComponent={
                  <div className="text-center my-2 bg-white">
                    <div
                      className="spinner-border text-secondary"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                }
                className="table table-striped table-hover"
              />
            </div>
          ) : (
            <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
              <img
                src="/img/leadership-empty.svg"
                className="img-fluid pirate-image"
                alt=""
              />
              <h2 className="leadership-empty-heading">It’s Empty Here!</h2>
              <p className="leadership-empty-para mt-2">
                You don’t have any zip codes at the moment. Let’s change that.
              </p>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-12 px-0 pt-4 d-flex justify-content-center">
          <button
          className="btn buy-lead-button"
          onClick={() => openModal("terms")}
        >
          Manage Zip Codes
        </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentZipCodes;